/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  addDecoderSizePrefix,
  addEncoderSizePrefix,
  combineCodec,
  getAddressDecoder,
  getAddressEncoder,
  getI64Decoder,
  getI64Encoder,
  getStructDecoder,
  getStructEncoder,
  getU32Decoder,
  getU32Encoder,
  getUtf8Decoder,
  getUtf8Encoder,
  type Address,
  type Codec,
  type Decoder,
  type Encoder,
} from "@solana/kit";

export type AgentRegisteredEvent = {
  agent: Address;
  owner: Address;
  name: string;
  timestamp: bigint;
};

export type AgentRegisteredEventArgs = {
  agent: Address;
  owner: Address;
  name: string;
  timestamp: number | bigint;
};

export function getAgentRegisteredEventEncoder(): Encoder<AgentRegisteredEventArgs> {
  return getStructEncoder([
    ["agent", getAddressEncoder()],
    ["owner", getAddressEncoder()],
    ["name", addEncoderSizePrefix(getUtf8Encoder(), getU32Encoder())],
    ["timestamp", getI64Encoder()],
  ]);
}

export function getAgentRegisteredEventDecoder(): Decoder<AgentRegisteredEvent> {
  return getStructDecoder([
    ["agent", getAddressDecoder()],
    ["owner", getAddressDecoder()],
    ["name", addDecoderSizePrefix(getUtf8Decoder(), getU32Decoder())],
    ["timestamp", getI64Decoder()],
  ]);
}

export function getAgentRegisteredEventCodec(): Codec<
  AgentRegisteredEventArgs,
  AgentRegisteredEvent
> {
  return combineCodec(
    getAgentRegisteredEventEncoder(),
    getAgentRegisteredEventDecoder(),
  );
}
